import { Router } from '@angular/router';
import { FeatureFlagService } from '../_services/feature-flag.service';
import * as i0 from "@angular/core";
import * as i1 from "../_services/feature-flag.service";
import * as i2 from "@angular/router";
var FeatureFlagGuardService = /** @class */ (function () {
    function FeatureFlagGuardService(featureFlagService, router) {
        this.featureFlagService = featureFlagService;
        this.router = router;
    }
    FeatureFlagGuardService.prototype.canActivate = function (route, state) {
        return this.checkFeatureFlag(route);
    };
    FeatureFlagGuardService.prototype.canActivateChild = function (route, state) {
        return this.checkFeatureFlag(route);
    };
    FeatureFlagGuardService.prototype.checkFeatureFlag = function (route) {
        var featureFlag = this.getRouteDataValue(route, 'featureFlag');
        if (!featureFlag) {
            return true;
        }
        var hasAccess = this.featureFlagService.hasFeatureFlag(featureFlag);
        if (!hasAccess) {
            console.log("FeatureFlagGuardService: Access denied for feature '" + featureFlag + "'");
            this.router.navigate(['/dashboard']);
            return false;
        }
        return true;
    };
    FeatureFlagGuardService.prototype.getRouteDataValue = function (route, key) {
        var current = route;
        while (current) {
            var value = current.data[key];
            if (value !== undefined && value !== null) {
                return value;
            }
            current = current.parent;
        }
        return undefined;
    };
    FeatureFlagGuardService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FeatureFlagGuardService_Factory() { return new FeatureFlagGuardService(i0.ɵɵinject(i1.FeatureFlagService), i0.ɵɵinject(i2.Router)); }, token: FeatureFlagGuardService, providedIn: "root" });
    return FeatureFlagGuardService;
}());
export { FeatureFlagGuardService };
